import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

/** Sentinel page size meaning “show every row”. */
export const LIST_PAGINATOR_ALL = 0;

@Component({
  selector: 'app-list-paginator',
  templateUrl: './list-paginator.component.html',
  styleUrls: ['./list-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatPaginator],
})
export class ListPaginatorComponent {
  readonly length = input(0);
  readonly pageSize = input(25);
  readonly pageIndex = input(0);
  readonly pageSizeOptions = input<number[]>([10, 25, 50, 100]);
  readonly includeAllOption = input(false);
  readonly busy = input(false);
  readonly ariaLabel = input('Select page');

  readonly page = output<PageEvent>();

  protected readonly allPageSize = LIST_PAGINATOR_ALL;

  /** MatPaginator needs a positive pageSize for range math when “All” is selected. */
  protected readonly effectivePageSize = computed(() => {
    const size = this.pageSize();
    if (size === LIST_PAGINATOR_ALL) {
      return Math.max(this.length(), 1);
    }
    return size;
  });

  protected readonly selectValue = computed(() => String(this.pageSize()));

  protected onPage(event: PageEvent): void {
    // When “All” is active, keep emitting the sentinel so parents stay in all-mode
    // even though MatPaginator uses length as the effective page size.
    if (this.pageSize() === LIST_PAGINATOR_ALL) {
      this.page.emit({
        ...event,
        pageSize: LIST_PAGINATOR_ALL,
        pageIndex: 0,
      });
      return;
    }
    this.page.emit(event);
  }

  protected onPageSizeChange(raw: string): void {
    const size = Number(raw);
    this.page.emit({
      pageIndex: 0,
      pageSize: Number.isFinite(size) ? size : 25,
      length: this.length(),
      previousPageIndex: this.pageIndex(),
    });
  }
}
